import { graphql } from "react-relay";

// gql
import "@components/team-join-create/TeamJoinCreate.gql";
import "@components/web-app-nav/web-app-nav-avatar-menu/WebAppNavAvatarMenu.gql";

/////////
// GQL //
/////////

export const fragments = {
  viewer: graphql`
    fragment WebAppTeamsRenderer_viewer on Viewer {
      ...WebAppNavAvatarMenu_viewer
      id
      user {
        flowStates(first: 1000000) {
          edges {
            node {
              id
              flowKey
              previousState
              current {
                id
                state
                percentComplete
                errorMessage
              }
              pending {
                id
                state
                percentComplete
                errorMessage
              }
            }
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              experiments
              id
              primaryOrgCalendar
            }
          }
        }

        webAppFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }

        chromeExtensionFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }
      }
    }
  `,
};

export const rendererQuery = graphql`
  query WebAppTeamsQuery($orgRelayId: ID!, $myCalendarIds: [String!]!) {
    viewer {
      ...TeamJoinCreate_viewer @arguments(orgRelayId: $orgRelayId, myCalendarIds: $myCalendarIds)
      id
      user {
        id
        orgs(first: 1000000) {
          edges {
            node {
              ...TeamJoinCreate_org
              userTeams {
                ... on TeamList {
                  list {
                    teamName
                    createdBy {
                      value
                    }
                    invitedMembers {
                      person {
                        ...AvatarPerson_orgPerson
                        profile {
                          givenName
                          familyName
                        }
                        primaryCalendarId
                      }
                    }
                    teamMembers {
                      person {
                        ...AvatarPerson_orgPerson
                        profile {
                          givenName
                          familyName
                        }
                        primaryCalendarId
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const query = graphql`
  query WebAppTeamsRendererQuery {
    viewer {
      ...WebAppTeamsRenderer_viewer
    }
  }
`;
